import { defaultQueryClientConfig } from '@iheartjane/react-query-utils';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router';

interface Props {
  children: ReactNode;
}

export const LegacyAppWrapper = ({ children }: Props) => {
  const queryClient = new QueryClient(defaultQueryClientConfig);
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>{children}</BrowserRouter>
      </QueryClientProvider>
    </HelmetProvider>
  );
};
